var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefectOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.708.293a1.001 1.001 0 0 0-1.416 0l-6 6a1.001 1.001 0 0 0 1.416 1.415l5.294-5.293 5.293 5.29a1.001 1.001 0 0 0 1.415-1.416l-6-6-.002.004zm6 11.999-6-6a1.001 1.001 0 0 0-1.416 0l-6 6a1.001 1.001 0 0 0 1.416 1.415l5.294-5.293 5.293 5.29a1.001 1.001 0 0 0 1.415-1.415l-.003.003z",
    fill: "#5A637D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefectOpen);
export default __webpack_public_path__ + "static/media/defect_open.cd4c7d959dae37f1fae843a34658b865.svg";
export { ForwardRef as ReactComponent };